export function SAVE_ACTIVITIES(state, [activities]){
    state.activities = activities
}

export function SAVE_DOWNLOADING(state, [downloading]){
    state.downloading = downloading
}